import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, DialogActions } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Image from "next/image";
import { ApiService } from "@/app/services/AppService";
import { ResponseObject } from "@/app/classes/main";
import { useRouter } from "next/navigation";
import { Loader } from "../MainLoader/Loader";

interface ScannerAuthProps {
  openInfo: any;
  handleClose: any;
  id: any;
  serviceHubSlug: any;
  slug: any;
}

interface GalleryItem {
  secureHttpPath: string;
}

interface BannersContentData {
  gallery?: GalleryItem[]; // The gallery might be undefined, so use optional chaining.
}

const ScannerAuth: React.FC<ScannerAuthProps> = ({
  openInfo,
  handleClose,
  id,
  serviceHubSlug,
  slug,
}) => {
  const router = useRouter();
  const apiService = React.useMemo(() => new ApiService(), []);
  const [bannersContentData, setbannersContentData] =
    React.useState<BannersContentData | null>(null);
  const [loading, setLoading] = React.useState(false);

  const getBannerPageContents = React.useCallback(async () => {
    try {
      if (id) {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.bannersPageContent + id
          );
        const bannersContentResponce = responseObject?.object;
        setbannersContentData(bannersContentResponce);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, id]);

  React.useEffect(() => {
    getBannerPageContents();
  }, [id, getBannerPageContents]);

  const handleNavigate = () => {
    router.push(`/${serviceHubSlug}/${slug}`);
    setLoading(true);
  };

  return (
    <React.Fragment>
      {loading && <Loader />}
      <Dialog
        open={openInfo}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            height: "100%",
            maxHeight: "100%",
            margin: 0,
          },
          "@media (max-width: 600px)": {
            "& .MuiDialog-paper": {
              width: "100%",
              height: "100%",
              maxHeight: "100%",
              margin: 0,
            },
          },
        }}
      >
        <DialogContent sx={{ padding: "4px !important" }}>
          <KeyboardBackspaceIcon
            sx={{
              background: "#fff",
              borderRadius: "1rem",
              padding: "4px",
              fontSize: "28px",
              position: "absolute",
              margin: "1rem",
              cursor: "pointer",
              color: "#000",
              boxShadow: "2px 1px 4px 1px rgba(0, 0, 0, 0.1)",
              zIndex: 100,
            }}
            onClick={handleClose}
          />
          <Box>
            {bannersContentData?.gallery?.map((item: any, index: any) => (
              <Image
                key={index}
                src={item?.secureHttpPath}
                width={2000}
                height={1000}
                style={{
                  margin: "auto",
                  objectFit: "cover",
                  width: "auto",
                  height: "auto",
                }}
                alt="Product_Authenticity"
              />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            sx={{
              width: "100%",
              borderRadius: "10rem",
              textTransform: "capitalize",
              fontSize: "1rem",
            }}
            onClick={handleNavigate}
          >
            Book Now
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ScannerAuth;
